(() => {
    frappe.ready(() => {
        const Orig = webshop.ProductList;
        if (!Orig) return;

        class ProductListPatched extends Orig {
            // Revert adj2: list view cart controls back to right-aligned
            // (original position before adj2). The price table + cart stay
            // on the same horizontal level in the bottom row (adj3).
            // No override needed — list.js base get_cart_action_row is
            // already right-aligned; we only need the bottom-row CSS to
            // revert for list view. The bulk prices move into the bottom row.

            get_item_details(item, settings) {
                let details = '';
                if (settings.custom_show_item_group) {
                    details += `
                    <div class="product-category" itemprop="name">
                        ${ item.item_group_display || item.item_group }
                    </div>
                `;
                }

                // Standard price display: keep the price here in the
                // details area (not in the bottom row — the list row is
                // wider, the price sits above the bulk prices as before).
                if (item.formatted_price) {
                    details += `
                    <div class="product-price" itemprop="offers" itemscope itemtype="https://schema.org/AggregateOffer">
                        ${ item.formatted_price || '' }
                `;

                    if (item.formatted_mrp) {
                        details += `
                        <small class="striked-price">
                            <s>${ item.formatted_mrp ? item.formatted_mrp.replace(/ +/g, "") : "" }</s>
                        </small>
                    `;
                    }

                    details += this.get_stock_availability(item, settings);
                    details += `</div>`;
                } else {
                    details += this.get_stock_availability(item, settings);
                }

                // Simple UOM view (PIT-TASK-2027-000285): conversion factors
                // "32/768/1536" of the UOMs configured in Webshop Settings.
                if (settings.show_simple_uom_view && item.simple_uom_view) {
                    details += `<div class="ws-simple-uom">${ item.simple_uom_view }</div>`;
                }

                return details;
            }

            // Bottom row: cart controls (right) + bulk prices (left) + desc
            // (adj3 — bulk prices on the same horizontal level as the cart)
            get_bottom_row_html(item, settings) {
                const cart_row = this.get_cart_action_row(item, settings);
                const desc = item.short_description
                    ? `<div class="ws-short-desc">${ item.short_description }</div>` : ``;

                // Bulk prices move into the bottom row (adj3)
                const bulk_html = item["bulk_prices_html"] || "";
                const bulk_wrapper = bulk_html ? `<div class="bulk-prices-wrapper">${bulk_html}</div>` : '';

                if (!desc && !cart_row && !bulk_wrapper) return ``;
                return `<div class="ws-bottom-row">${ bulk_wrapper }${ desc }${ cart_row }</div>`;
            }
        }
        webshop.ProductList = ProductListPatched;
    });
})();
